export function crudPermissionAdapter(backendCrud) {
    var _a, _b, _c, _d;
    if (backendCrud) {
        return {
            canCreate: (_a = backendCrud.canCreate) !== null && _a !== void 0 ? _a : false,
            canRead: (_b = backendCrud.canView) !== null && _b !== void 0 ? _b : false,
            canDelete: (_c = backendCrud.canDelete) !== null && _c !== void 0 ? _c : false,
            canUpdate: (_d = backendCrud.canEdit) !== null && _d !== void 0 ? _d : false,
        };
    }
    return {
        canCreate: false,
        canRead: false,
        canUpdate: false,
        canDelete: false,
    };
}
